export const trademark_statuses = [
    'filed',
    'published',
    'registered',
    'pending',
    'cancelled',
    'withdrawn',
    'refused',
    'opposed',
    'surrendered',
    'cancellation_procedure',
    'expired',
    'registration_pending'
];
